(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-dom"), require("immutable"), require("react-redux"), require("redux"), require("@fiverr/globals"), require("react"), require("redux-thunk"));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "immutable", "react-redux", "redux", "@fiverr/globals", "react", "redux-thunk"], factory);
	else if(typeof exports === 'object')
		exports["Reviews"] = factory(require("react-dom"), require("immutable"), require("react-redux"), require("redux"), require("@fiverr/globals"), require("react"), require("redux-thunk"));
	else
		root["Reviews"] = factory(root["ReactDOM"], root["Immutable"], root["ReactRedux"], root["Redux"], root["@fiverr/globals"], root["React"], root["ReduxThunk"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_wLXD__, __WEBPACK_EXTERNAL_MODULE_gNLg__, __WEBPACK_EXTERNAL_MODULE_H_qB__, __WEBPACK_EXTERNAL_MODULE_dJD___, __WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_SHgP__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/reviews/@fiverr/reviews/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/kEz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preview_img_PreviewImg__ = __webpack_require__("vyFy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ReviewsItems = function (_React$Component) {
    _inherits(ReviewsItems, _React$Component);

    function ReviewsItems() {
        _classCallCheck(this, ReviewsItems);

        return _possibleConstructorReturn(this, (ReviewsItems.__proto__ || Object.getPrototypeOf(ReviewsItems)).apply(this, arguments));
    }

    _createClass(ReviewsItems, [{
        key: 'createMarkupThumbnail',
        value: function createMarkupThumbnail(rater_image) {
            return { __html: rater_image };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                ps = _props.ps,
                review = _props.review,
                gigId = _props.gigId;


            var isSeller = review.get('is_seller'),
                shouldHideReview = isSeller && !gigId || isSeller && ps.isMobileResponsive,
                imgSize = isSeller ? '40' : '65';

            if (shouldHideReview) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'li',
                { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('cf', { seller: isSeller }) },
                ps.isMobileResponsive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'figure',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'user-pict-40', dangerouslySetInnerHTML: this.createMarkupThumbnail(review.get('rater_image')) })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'review' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'a',
                            { href: review.get('rater_link') },
                            review.get('rater_username')
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'star-rating-s15 rate-' + review.get('value') + ' rf' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            review.get('comment')
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'date' },
                            review.get('created_at'),
                            ' ',
                            i18n.t('reviews.general.ago')
                        )
                    )
                ),
                !ps.isMobileResponsive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'figure',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'user-pict-' + imgSize, dangerouslySetInnerHTML: this.createMarkupThumbnail(review.get('rater_image')) })
                    ),
                    !isSeller && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__preview_img_PreviewImg__["a" /* default */], { smallImgUrl: review.get('work_sample_small'), bigImgUrl: review.get('work_sample'), ps: ps }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'review' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'review-rating' },
                            isSeller ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'span',
                                { className: 'review-user seller-feedback' },
                                i18n.t('reviews.users.show.seller_feedback')
                            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'a',
                                { href: review.get('rater_link'), className: 'review-user' },
                                review.get('rater_username')
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'star-rating-s10 rate-' + review.get('value') })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            review.get('comment')
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'date' },
                            review.get('created_at'),
                            ' ',
                            i18n.t('reviews.general.ago')
                        )
                    )
                )
            );
        }
    }]);

    return ReviewsItems;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReviewsItems);

/***/ }),

/***/ "0Bgt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter_Filter__ = __webpack_require__("Cy6b");



var HeaderDesktop = function HeaderDesktop(_ref) {
    var data = _ref.data;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__filter_Filter__["a" /* default */], { fetchReviews: data.general_reviews,
            type: data.reviews_type,
            lastStar: data.lastStar }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'alt' },
            data.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'user-rating' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'star-rating-s15 rate-' + data.rating_ten }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'total-rating-out-five' },
                data.rating_five
            ),
            !data.hasGigId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'total-rating' },
                '( ',
                data.total_count,
                ' )'
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderDesktop);

/***/ }),

/***/ "2uFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configureStore; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var redux = __webpack_require__("dJD+"),
    ReduxThunk = __webpack_require__("SHgP").default;

var finalCreateStore = redux.compose(redux.applyMiddleware(ReduxThunk), (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : function (f) {
    return f;
})(redux.createStore);

var configureStore = function configureStore(initialState, rootReducer) {
    var store = finalCreateStore(rootReducer, initialState);

    return store;
};

/***/ }),

/***/ "BjP8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var HeaderMobileCollapse = function HeaderMobileCollapse(_ref) {
    var data = _ref.data,
        toggleCollapsed = _ref.toggleCollapsed;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "header",
        { onClick: function onClick() {
                toggleCollapsed();
            } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", { className: "ficon ficon-chevron-down" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { className: "alt" },
            data.title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { className: "star-rating-s15 rate-" + data.rating_ten + " p-l-10" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "span",
            { className: "total-rating-out-five" },
            "(",
            data.rating_five,
            ")"
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderMobileCollapse);

/***/ }),

/***/ "Cy6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);



var FilterReviews = function FilterReviews(_ref) {
    var fetchReviews = _ref.fetchReviews,
        type = _ref.type,
        lastStar = _ref.lastStar;


    var gaEvents = ' data-gtm-category=gig-page-old data-gtm-action=click ';

    var handleFetchReviews = function handleFetchReviews(e) {
        fetchReviews(e, type, lastStar);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'filter-dd rf' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'select',
            { onChange: handleFetchReviews },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { className: 'js-gtm-event-auto', value: 'all', 'data-gtm-action': gaEvents, 'data-gtm-label': 'reviews-most-recent', 'data-reviews-type': 'all', rel: 'noindex, nofollow' },
                i18n.t('reviews.gigs._inner_gig.drop_most_recent')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { className: 'js-gtm-event-auto', value: 'positive', 'data-gtm-action': gaEvents, 'data-gtm-label': 'reviews-positive', 'data-reviews-type': 'positive', rel: 'noindex, nofollow' },
                i18n.t('reviews.gigs._inner_gig.drop_positive')
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { className: 'js-gtm-event-auto', value: 'negative', 'data-gtm-action': gaEvents, 'data-gtm-label': 'reviews-negatve', 'data-reviews-type': 'negative', rel: 'noindex, nofollow' },
                i18n.t('reviews.gigs._inner_gig.drop_negative')
            )
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (FilterReviews);

/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "ENuR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_more_btn_LoadMoreBtn__ = __webpack_require__("yvvX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviews_items_ReviewsItems__ = __webpack_require__("/kEz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_list_scss__ = __webpack_require__("VsHF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_list_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__reviews_list_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ReviewsList = function (_React$Component) {
    _inherits(ReviewsList, _React$Component);

    function ReviewsList() {
        _classCallCheck(this, ReviewsList);

        return _possibleConstructorReturn(this, (ReviewsList.__proto__ || Object.getPrototypeOf(ReviewsList)).apply(this, arguments));
    }

    _createClass(ReviewsList, [{
        key: 'genKey',
        value: function genKey(index, raterUsername) {
            return index + '-' + raterUsername;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                ps = _props.ps,
                stars = _props.stars,
                type = _props.type,
                fetchReviews = _props.fetchReviews,
                lastStar = _props.lastStar,
                showLoadMore = _props.showLoadMore,
                gigId = _props.gigId;

            // no reviews

            if (!stars || stars.size === 0) {
                return null;
            }

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'review-list' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    null,
                    stars.map(function (review, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__reviews_items_ReviewsItems__["a" /* default */], { key: _this2.genKey(index, review.get('rater_username')), review: review, ps: ps, gigId: gigId });
                    })
                ),
                showLoadMore && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__load_more_btn_LoadMoreBtn__["a" /* default */], { fetchReviews: fetchReviews,
                    type: type,
                    lastStar: lastStar })
            );
        }
    }]);

    return ReviewsList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReviewsList);

/***/ }),

/***/ "H/qB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_H_qB__;

/***/ }),

/***/ "HW6M":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "NWgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filter_Filter__ = __webpack_require__("Cy6b");



var HeaderMobile = function HeaderMobile(_ref) {
    var data = _ref.data;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__filter_Filter__["a" /* default */], { fetchReviews: data.general_reviews,
            type: data.type,
            lastStar: data.lastStar }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'alt' },
            data.title
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderMobile);

/***/ }),

/***/ "SHgP":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_SHgP__;

/***/ }),

/***/ "TWjy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VsHF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZMjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_ranking_scss__ = __webpack_require__("bax2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_ranking_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_ranking_scss__);



var RankingUser = function RankingUser(_ref) {
    var star_summary = _ref.star_summary,
        rating_base_ten = _ref.rating_base_ten,
        rating_base_five = _ref.rating_base_five,
        collapse = _ref.collapse,
        ps = _ref.ps;

    if (!star_summary || star_summary.size === 0) {
        return null;
    }

    var counter = 0;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'reviews-header-stars cf' },
        ps.isMobileResponsive && !collapse && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'rating-category average m-r-5' },
                i18n.t('reviews.users.user_show.average_rating'),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'total-rating-out-five p-l-5' },
                    '(',
                    rating_base_five,
                    ')'
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'star-rating-s15 rate-' + rating_base_ten + ' rf' })
        ),
        star_summary.toArray().map(function (value, index) {
            counter++;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'rating-category' },
                    i18n.t('reviews.gigs._rating.q' + counter)
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'star-rating-s15 rate-' + value })
            );
        })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (RankingUser);

/***/ }),

/***/ "bax2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dJD+":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_dJD___;

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"reviews":{"general":{"show_more":"Show More","ago":"ago","reviews":"Reviews"},"users":{"user_show":{"my_reviews":"My Reviews","count_reviews":"%{count} Reviews","seller_reviews":"%{name}'s Reviews","reviews_not_found":"There Are Currently No %{type}...","average_rating":"Average rating"},"show":{"reviewed_by":"Reviewed by","seller_feedback":"Seller's Feedback"}},"gigs":{"_inner_gig":{"drop_most_recent":"Most Recent","drop_positive":"Positive Reviews","drop_negative":"Negative Reviews"},"_rating":{"q1":"Seller Communication","q2":"Service as Described","q3":"Would Recommend"}}}}

/***/ }),

/***/ "fATY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gNLg":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_gNLg__;

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("wLXD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviews_index__ = __webpack_require__("wGqK");




var componentElm = typeof document !== 'undefined' && document.getElementById('Reviews-component');

if (componentElm) {
    var initialState = window.initialData.Reviews;

    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__reviews_index__["a" /* default */], initialState), componentElm);
}

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_2__reviews_index__["a" /* default */]);

/***/ }),

/***/ "m8ud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mwEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("H/qB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("dJD+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_list_ReviewsList__ = __webpack_require__("ENuR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_ranking_RankingUser__ = __webpack_require__("ZMjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__headers_HeaderDesktop__ = __webpack_require__("0Bgt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__headers_HeaderMobile__ = __webpack_require__("NWgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__headers_HeaderMobileCollapse__ = __webpack_require__("BjP8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__no_reviews_NoReviews__ = __webpack_require__("ujtn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__module__ = __webpack_require__("ny+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translations_en_json__ = __webpack_require__("eIBB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__translations_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__translations_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fiverr_globals__ = __webpack_require__("E4I8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fiverr_globals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__fiverr_globals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__my_reviews_scss__ = __webpack_require__("TWjy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__my_reviews_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__my_reviews_scss__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Index = function (_React$Component) {
    _inherits(Index, _React$Component);

    function Index() {
        _classCallCheck(this, Index);

        var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this));

        i18n.add(__WEBPACK_IMPORTED_MODULE_10__translations_en_json___default.a);

        _this.toggleCollapsed = _this.toggleCollapsed.bind(_this);

        _this.state = {
            showReviews: false
        };
        return _this;
    }

    _createClass(Index, [{
        key: 'toggleCollapsed',
        value: function toggleCollapsed() {
            this.setState({
                showReviews: !this.state.showReviews
            });
        }
    }, {
        key: 'headerTitle',
        value: function headerTitle(totalCount, sellerUserName) {
            if (this.props.gigId) {
                return i18n.t('reviews.users.user_show.count_reviews', { count: totalCount });
            } else if (this.isMe()) {
                return i18n.t('reviews.users.user_show.my_reviews');
            } else if (this.props.ps.isMobileResponsive) {
                return i18n.t('reviews.users.user_show.count_reviews', { count: totalCount });
            } else {
                return i18n.t('reviews.users.user_show.seller_reviews', { name: sellerUserName });
            }
        }
    }, {
        key: 'mainClassName',
        value: function mainClassName() {
            var collapseClass = this.props.collapse ? 'reviews-collapse' : '',
                showClass = this.state.showReviews ? 'show' : '';

            return 'my-reviews js-client-service-source ' + collapseClass + ' ' + showClass;
        }
    }, {
        key: 'userRatingCal',
        value: function userRatingCal(userRating) {
            return Math.round(userRating / 10);
        }
    }, {
        key: 'isMe',
        value: function isMe() {
            var ps = this.props.ps;

            return ps.currentUser ? ps.currentUser.userName === this.props.sellerUserName : false;
        }
    }, {
        key: 'round',
        value: function round(value) {
            return Math.round(value * 10) / 10;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                ps = _props.ps,
                stars = _props.stars,
                star_summary = _props.star_summary,
                showLoadMore = _props.showLoadMore,
                user_rating = _props.user_rating,
                sellerUserName = _props.sellerUserName,
                total_count = _props.total_count,
                type = _props.type,
                lastStar = _props.lastStar,
                fetchReviews = _props.fetchReviews,
                collapse = _props.collapse,
                gigId = _props.gigId;


            var userRating = user_rating,
                totalCount = total_count ? total_count.toLocaleString() : 0,
                ratingBaseTen = this.userRatingCal(userRating),
                ratingBaseFive = this.round(userRating / 20),
                hasGigId = !!gigId;

            var header_props = {
                reviews_type: type,
                total_count: totalCount,
                general_reviews: fetchReviews,
                rating_ten: ratingBaseTen,
                rating_five: ratingBaseFive,
                title: this.headerTitle(totalCount, sellerUserName),
                hasGigId: hasGigId
            };

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: this.mainClassName() },
                ps.isMobileResponsive && collapse && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__headers_HeaderMobileCollapse__["a" /* default */], { data: header_props,
                    toggleCollapsed: this.toggleCollapsed }),
                ps.isMobileResponsive && !collapse && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__headers_HeaderMobile__["a" /* default */], { data: header_props }),
                !ps.isMobileResponsive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__headers_HeaderDesktop__["a" /* default */], { data: header_props }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'reviews-wrap' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__user_ranking_RankingUser__["a" /* default */], { star_summary: star_summary,
                        rating_base_ten: ratingBaseTen,
                        rating_base_five: ratingBaseFive,
                        collapse: collapse,
                        ps: ps }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reviews_list_ReviewsList__["a" /* default */], { stars: stars,
                        type: type,
                        fetchReviews: fetchReviews,
                        lastStar: lastStar,
                        showLoadMore: showLoadMore,
                        ps: ps,
                        gigId: gigId })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__no_reviews_NoReviews__["a" /* default */], { stars: stars,
                    type: type })
            );
        }
    }]);

    return Index;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        stars: state.get('stars'),
        user_rating: state.get('user_rating'),
        star_summary: state.get('star_summary'),
        total_count: state.get('total_count'),
        showLoadMore: state.get('has_more_pages'),
        sellerUserName: state.get('username'),
        type: state.get('type'),
        lastStar: state.get('last_star_rating_id'),
        collapse: state.get('collapse'),
        gigId: state.get('gigId')
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_9__module__, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(Index));

/***/ }),

/***/ "ny+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["updateReviews"] = updateReviews;
/* harmony export (immutable) */ __webpack_exports__["fetchReviews"] = fetchReviews;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("gNLg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var UPDATE_REVIEWS = 'reviews/update_reviews';

var PAGE_SIZE = 5;

var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS({});

/* harmony default export */ __webpack_exports__["default"] = (function () {
    var _state$get;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    switch (action.type) {
        case UPDATE_REVIEWS:
            var newStarsList = action.isFilter ? action.list.stars : (_state$get = state.get('stars')).push.apply(_state$get, _toConsumableArray(action.list.stars)).toJS();
            state = state.update('stars', function () {
                return __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(newStarsList);
            });
            state = state.update('has_more_pages', function () {
                return action.list.has_more_pages;
            });
            state = state.update('type', function () {
                return action.filterType;
            });
            state = state.update('last_star_rating_id', function () {
                return action.list.last_star_rating_id;
            });
            return state;
        default:
            return state;
    }
});

function updateReviews(list, filterType, isFilter) {
    return {
        type: UPDATE_REVIEWS,
        filterType: filterType,
        isFilter: isFilter,
        list: list
    };
}

/** Load More & Order By reviews */
function fetchReviews(event, type, lastStar) {
    return function (dispatch, state) {

        var isFilter = event.target.tagName === 'SELECT',
            filterType = isFilter ? event.target.value : type,
            idType = state().get('gigId') ? 'gig' : 'user',
            id = state().get(idType + 'Id');

        var url = '/ratings/index?' + idType + '_id=' + id + '&type=' + filterType + '&page_size=' + PAGE_SIZE;

        if (!isFilter) {
            url += '&last_star_rating_id=' + lastStar;
        }

        gofor(url).then(function (response) {
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            return response.json();
        }).then(function (res) {
            dispatch(updateReviews(res, filterType, isFilter));
        });
    };
}

/***/ }),

/***/ "p+G3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__no_reviews_scss__ = __webpack_require__("p+G3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__no_reviews_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__no_reviews_scss__);



var NoReviews = function NoReviews(_ref) {
    var stars = _ref.stars,
        type = _ref.type;

    // if we have reviews, return null - don't print
    if (stars && stars.size > 0) {
        return null;
    }

    var typeString = type ? i18n.t('reviews.gigs._inner_gig.drop_' + type) : i18n.t('reviews.general.reviews');

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-reviews' },
        i18n.t('reviews.users.user_show.reviews_not_found', { type: typeString })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (NoReviews);

/***/ }),

/***/ "vyFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview_img_scss__ = __webpack_require__("fATY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preview_img_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__preview_img_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var PreviewImg = function PreviewImg(_ref) {
    var smallImgUrl = _ref.smallImgUrl,
        bigImgUrl = _ref.bigImgUrl,
        ps = _ref.ps;

    if (smallImgUrl) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'preview-img' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'img-thumbnail', style: { backgroundImage: 'url(' + smallImgUrl + ')' } }),
            !ps.isMobileResponsive && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'big-img' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: bigImgUrl })
            )
        );
    }

    return null;
};

/* harmony default export */ __webpack_exports__["a"] = (PreviewImg);

/***/ }),

/***/ "wGqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("gNLg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("H/qB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___ = __webpack_require__("2uFj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__module__ = __webpack_require__("ny+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Reviews__ = __webpack_require__("mwEj");







var Index = function Index(_ref) {
    var initialState = _ref.initialState,
        pageScope = _ref.pageScope;

    initialState = __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.fromJS(initialState) || {};

    var store = Object(__WEBPACK_IMPORTED_MODULE_3__config___["a" /* configureStore */])(initialState, __WEBPACK_IMPORTED_MODULE_4__module__["default"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_redux__["Provider"],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Reviews__["a" /* default */], { ps: pageScope })
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Index);

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ }),

/***/ "yvvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("Jmof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_more_btn_scss__ = __webpack_require__("m8ud");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_more_btn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__load_more_btn_scss__);



var LoadMoreBtn = function LoadMoreBtn(_ref) {
    var fetchReviews = _ref.fetchReviews,
        type = _ref.type,
        lastStar = _ref.lastStar;

    var handleFetchReviews = function handleFetchReviews(e) {
        fetchReviews(e, type, lastStar);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'load-more-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '#!', className: 'js-gtm-event-auto', onClick: handleFetchReviews, 'data-gtm-category': 'gig-page-gig_tracking_type', 'data-gtm-action': 'click', 'data-gtm-label': 'reviews-show-more' },
            i18n.t('reviews.general.show_more')
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (LoadMoreBtn);

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.680e0fd3711d36c5dab1.js